export default {
  methods: {
    async authorizeEmail(input, model, email) {
      if (
        !!email &&
        email.includes("@") &&
        model.rules.email.authorize &&
        !this.authorizingEmail
      ) {
        this.authorizingEmail = true;
        try {
          this.emailAuthorized = (
            await model.authorizeEmail(email)
          ).data.authorized;
          if (this.emailAuthorized === false) {
            this.markInputInvalid(input);
          }
        } catch (error) {
          // Do nothing e.g. if too many requests (429)
        }
        this.authorizingEmail = false;
      }
    },

    markInputInvalid(input) {
      input.classList.remove("tito-valid");
      input.classList.add("tito-invalid");
      const label = input.previousElementSibling;
      label.classList.remove("tito-valid");
      label.classList.add("tito-invalid");
    },

    resetEmailAuthorized(e) {
      if (this.emailAuthorized != null) {
        this.emailAuthorized = null;
        const input = e.target;
        const label = input.previousElementSibling;
        input.classList.remove("tito-invalid");
        label.classList.remove("tito-invalid");
      }
    },
  },
};
